import React, { useEffect } from 'react';

function DisablePasteGlobally() {

    const handlePaste = (event) => {
        event.preventDefault();
    };

    const handleCopy = (event) => {
        event.preventDefault();
    };

    useEffect(() => {
        if (window.location.href.includes("user")) {
            document.addEventListener('paste', handlePaste);
            document.addEventListener('copy', handleCopy);
        } else {
            document.removeEventListener('paste', handlePaste);
            document.removeEventListener('copy', handleCopy);
        }

        return () => {
            document.removeEventListener('paste', handlePaste);
            document.removeEventListener('copy', handleCopy);
        };
    }, [window.location.href]);


    return null; // This component doesn't render anything
}

export default DisablePasteGlobally;
